module.exports = __webpack_public_path__ + "img/birds_preview.160b1390.png";